var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Form } from 'antd';
var Item = Form.Item;
var PRIVACY_LABEL_COLORS = {
    warning: 'red',
    normal: 'blue',
    private: 'orange'
};
export var PriceForm = styled(Form)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  label {\n    position: inherit;\n  }\n  .ant-form-item-label {\n    overflow: auto;\n    position: inherit;\n    white-space: inherit;\n  }\n"], ["\n  label {\n    position: inherit;\n  }\n  .ant-form-item-label {\n    overflow: auto;\n    position: inherit;\n    white-space: inherit;\n  }\n"])));
export var Label = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 5px;\n  font-weight: 600;\n  color: #212121;\n"], ["\n  margin-bottom: 5px;\n  font-weight: 600;\n  color: #212121;\n"])));
export var Plan = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var type = _a.type;
    return PRIVACY_LABEL_COLORS[type];
});
export var StyledItem = styled(Item)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var StyledModalFooter = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: sticky;\n  padding: 25px 0;\n  bottom: 0;\n  background: white;\n  text-align: right;\n"], ["\n  position: sticky;\n  padding: 25px 0;\n  bottom: 0;\n  background: white;\n  text-align: right;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
